'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { VisuallyHidden } from '../visually-hidden/visually-hidden';
import { gleamDotRecipe } from './styles/gleam-dot.styles';
import type { GleamDotPropsInterface } from './types/gleam-dot.types';

/**
 * @since 10.0.0
 */

export const GleamDot = forwardRef<HTMLSpanElement, GleamDotPropsInterface>(
  (props: GleamDotPropsInterface, forwardedRef) => {
    const { tone = 'default', onImpact = false, count, label, className, css: cssProp } = props;

    return (
      <span
        className={cx('c11n', css(gleamDotRecipe.raw({ tone, onImpact }), cssProp), className)}
        data-c11n-component="Gleam.Dot"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
      >
        <VisuallyHidden>{label || count}</VisuallyHidden>
      </span>
    );
  },
);

GleamDot.displayName = 'Gleam.Dot';
